import React from "react";
import { ImageLink } from "../../../../utils/constants";
import StatusBadge from "../../../../Components/StatusBadge";

const PaymentCard = ({ payment, }) => {
  if (!payment) return null;

  const { paymentMethod, status, transactionId, receiptImage } = payment;
 
  return (
    <div className="card rounded-3 shadow-sm mb-3">
      <div className="card-body">
        <h6 className="heading_custom">Payment Details</h6>

       <p className="mb-0">
  Method: {paymentMethod || "N/A"} <br />
  Status:{" "}
  <span>
    <StatusBadge status={status} />
  </span>
</p>


        <p>Transaction Id: {transactionId || "N/A"}</p>

        <div className="d-flex align-items-center gap-3">
          <p className="mb-0">
            <span>Receipt Image:</span>
          </p>
          {receiptImage ? (
            <a
              href={ImageLink(receiptImage)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={ImageLink(receiptImage)}
                alt="Receipt"
                className="img-thumbnail"
                style={{ height: "60px", width: "60px", cursor: "pointer" }}
              />
            </a>
          ) : (
            <span className="text-muted">N/A</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
